import { css } from '@/styled-system/css';

export const mediaObjectContentStyles = css.raw({
  flexGrow: 1,
});
